import {
  JsonSchema,
  RowData,
  LandingPageOptions,
  IAMUserState,
} from "../../../../types";
import ExcelJS from "exceljs";
import saveAs from "file-saver";
import {
  ChildCollection,
  ChildWorksheet,
  ExportContext,
} from "../../../../types/types.export";
import {
  getFieldsToExportForBaseAndChild,
  getParentIdentifier,
} from "../export/identifierBuilder";
import { getChildCollections } from "../export/schemaInspector";
import { populateWorksheet } from "../export/worksheetBuilder";
import { buildChildRow } from "../export/childSheetBuilder";

// for flattened merged rows
// for downloading validated flattened merged rows sent for validation

export const exportMappedMergedRowsToExcel = async ({
  fileName,
  schema,
  selected,
  rowDataList,
  iamUserState,
}: {
  fileName: string;
  schema: JsonSchema;
  selected: LandingPageOptions;
  rowDataList: RowData[];
  iamUserState: IAMUserState;
}): Promise<void> => {
  const workbook = new ExcelJS.Workbook();

  const childCollection = getChildCollections(schema)[0];

  if (!childCollection) {
    return;
  }

  const context: ExportContext = {
    exportFields: getFieldsToExportForBaseAndChild(schema),
    setupName: selected.setup.label,
    schema,
    iamUserState,
  };

  const worksheet = buildMappedMergedWorksheet(
    rowDataList,
    childCollection,
    context,
  );
  const excelWorksheet = workbook.addWorksheet(worksheet.sheetName);

  populateWorksheet(excelWorksheet, worksheet.rows);

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
};

export const buildMappedMergedWorksheet = (
  rowDataList: RowData[],
  childCollection: ChildCollection,
  context: ExportContext,
): ChildWorksheet => {
  const parentIdentifierFields = getParentIdentifier(context);
  // use the same rowdata for child and parent since it's a flattened merged row
  const rows = rowDataList.map((rowData) =>
    buildChildRow(
      rowData,
      parentIdentifierFields.fields,
      rowData,
      childCollection,
      context,
    ),
  );

  return {
    field: childCollection.field,
    sheetName: context.setupName,
    rows,
    firstRowMap: new Map(),
  };
};
